$('button#prev')?.click((e) => {
    if(['winback-pick-plan'].includes(header_page)) {
      location.href = "https://cosmotogether.com/pages/welcome-back-offer/";
    } else if(['winback-cosmo-care'].includes(header_page)) {
      window.location = `/pages/winback-plan-details`;
    } else if(['winback-upsell'].includes(header_page)) {
      window.location = `/pages/winback-cosmo-care`;
    } else if(['winback-review'].includes(header_page)) {
      window.location = `/pages/winback-upsell`;
    }
    
    if(['jrtrack5-renewed-cosmo-care'].includes(header_page)) {
      location.href = "https://cosmotogether.com/products/jrtrack-5-renewed/";
    } else if(['jrtrack5-renewed-upsell'].includes(header_page)) {
      window.location = `/pages/jrtrack5-renewed-cosmo-care`;
    } else if(['jrtrack5-renewed-order-review'].includes(header_page)) {
      window.location = `/pages/jrtrack5-renewed-upsell`;
    } 


    else if(['1000-hrs-cosmo-care'].includes(header_page)) {
        location.href = "https://cosmotogether.com/products/1000-hours-outside-bundle/";
      } else if(['1000-hrs-upsell'].includes(header_page)) {
        window.location = `/pages/1000-hrs-activation-cosmo-care`;
      } else if(['1000-hrs-review'].includes(header_page)) {
        window.location = `/pages/1000-hrs-activation-upsell`;
      } 
       else {
      alert(`Previous Button clicked from ${header_page}`);
    }
  });
  
  $('button#next')?.click((e) => {
    if(['winback-pick-plan'].includes(header_page)) {
         $('button#next').prop("disabled",true);
        addProduct();
        
      } else if(['winback-cosmo-care'].includes(header_page)) {
        window.location = `/pages/winback-upsell`;
      } else if(['winback-upsell'].includes(header_page)) {
        window.location = `/pages/winback-order-review`;
      } else if(['winback-review'].includes(header_page)) {
        $('html, body').animate({
            scrollTop: $("#checkout").offset().top
          }, 2000);
      }

       if(['jrtrack5-renewed-cosmo-care'].includes(header_page)) {
        location.href = "https://cosmotogether.com/pages/jrtrack5-renewed-upsell/";
      } else if(['jrtrack5-renewed-upsell'].includes(header_page)) {
        window.location = `/pages/jrtrack5-renewed-order-review`;
      } else if(['jrtrack5-renewed-order-review'].includes(header_page)) {
        $('html, body').animate({
          scrollTop: $("#checkout").offset().top
        }, 2000);
      } 
 
      
        else if(['1000-hrs-cosmo-care'].includes(header_page)) {
            location.href = "/pages/1000-hrs-activation-upsell";
        } else if(['1000-hrs-upsell'].includes(header_page)) {
            window.location = `/pages/1000-hrs-activation-order-review`;
        } else if(['1000-hrs-review'].includes(header_page)) {
            $('html, body').animate({
                scrollTop: $("#checkout").offset().top
              }, 2000);
        } 
         else {
              alert(`Next Button clicked from ${header_page}`);
        }
  });